import type { HttpMethod } from '@onefootprint/request-types/dashboard';
import type { OutputType } from '@/playbook-builder/utils/output-type';

export const MOCK_RESPONSE_VALUE = '__mock_response__';

// A single `data.<key>` <- `$.<selector>` extraction from the response.
export type FormFieldExtraction = {
  key: string;
  selector: string;
  // Undefined = no type chosen = legacy "no schema" (value coerced to a string). "any" stores the
  // raw JSON value ({}); a concrete type validates and stores the value as that type.
  outputType?: OutputType;
  // Whether a missing/null value fails the node. Ignored for no-schema (legacy) fields.
  isRequired: boolean;
};

// Optional assignment of the entire response body to a single `data.<key>`. There is at most one, and
// it is stored as-is and declared "any" (the body can be any JSON shape), so there is no type to choose.
export type FormEntireBodyAssignment = {
  enabled: boolean;
  key: string;
};

export type HttpPropertiesFormData = {
  headers: Array<{ key: string; value: string }>;
  queryParams: Array<{ key: string; value: string }>;
  body: string;
  method: HttpMethod;
  path?: string;
};

export type ExternalApiFormData = {
  config: {
    name: string;
    // Only the url is for display (from proxy config)
    url?: string;
    proxyConfig?: string;
    sandboxProxyConfig?: string;
    useMockData?: string;
    requireSuccessStatusCode: boolean;
    // Optionally store the entire response body under one key.
    entireBody: FormEntireBodyAssignment;
    // Specific JSONPath extractions, each mapped to its own onboarding data key.
    fieldExtractions: Array<FormFieldExtraction>;
    useSandboxHttpProperties: boolean;
  } & HttpPropertiesFormData & {
      sandboxHttpProperties: HttpPropertiesFormData;
    };
};
